import { containerClasses, SxProps } from '@mui/material'
import { BREAKPOINT_VALUES } from '@/styles'

interface ContainerStyles {
  container: SxProps
}

export const containerStyles: ContainerStyles = {
  container: {
    px: {
      xs: 2.5,
      md: 3,
    },
    [`&:not(.${containerClasses.fixed})`]: {
      width: '100%',
      maxWidth: '100%',
    },
    [`> .${containerClasses.root}`]: {
      px: {
        xs: 0,
        sm: 3,
      },
    },
    [`&.${containerClasses.fixed}`]: {
      maxWidth: {
        xl: BREAKPOINT_VALUES.XL + 1,
      },
    },
  },
}
